import { render, staticRenderFns } from "./tag-input.vue?vue&type=template&id=69648ea0&scoped=true&"
import script from "./tag-input.vue?vue&type=script&lang=js&"
export * from "./tag-input.vue?vue&type=script&lang=js&"
import style0 from "./tag-input.vue?vue&type=style&index=0&id=69648ea0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69648ea0",
  null
  
)

component.options.__file = "tag-input.vue"
export default component.exports